// Typelizer digest 8bd2b8a2829c6b09283e82b177f86695
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/payments/:payment_id/documents */
  create: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/documents', params, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/payments/:payment_id/documents/:id */
  destroy: (
    params: { paymentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/documents/:id', params, options),
    method: 'delete',
  }),
}
